export default "__VITE_ASSET__eec6211b__"